// extracted by css-extract-rspack-plugin
module.exports =  {"sandwich":"Sandwich__sandwich___FvS6Q","stretch":"Sandwich__stretch___A_4ax","full":"Sandwich__full___y3uFO","bun":"Sandwich__bun___Ll8vj","content":"Sandwich__content___lHqFX"};